import { AuthWrapper } from "./AuthWrapper";

export default AuthWrapper;
